import DynamicRouterView from '@/components/common/layout/DynamicRouterView.vue';

import Email from '@/components/sponsorship/email/SponsorshipEmail.vue';
import Message from '@/components/sponsorship/email/SponsorshipEmailMessage.vue';
import Confirmation from '@/components/sponsorship/default/SponsorshipConfirmation.vue';
import HowItWorks from '@/components/sponsorship/default/SponsorshipHowItWorks.vue';

import {
  PerksView,
  Sponsorship,
} from '@/views/default';

import {
  SponsorshipModal,
} from '@/views/modal';

const perks = {
  path: 'perks',
  components: {
    default: DynamicRouterView,
  },
  children: [
    { path: '', redirect: 'deals' },
    { path: 'deals', component: PerksView, name: 'clientPerksDeals' },
    {
      path: 'sponsorship',
      name: 'clientPerksSponsorship',
      components: {
        default: Sponsorship,
        modal: SponsorshipModal,
      },
    },
    {
      path: 'sponsorship/email',
      name: 'clientSponsorshipEmail',
      component: Email,
    },
    {
      path: 'sponsorship/message',
      name: 'clientSponsorshipMessage',
      component: Message,
    },
    {
      path: 'sponsorship/confirmation',
      name: 'clientSponsorshipConfirmation',
      component: Confirmation,
    },
    {
      path: 'sponsorship/how-it-works',
      name: 'clientSponsorshipHowItWorks',
      component: HowItWorks,
    },
  ],
};

export default perks;
